import { getAuditTrailForEntity } from '@/domains/settings';
import { queryKeys } from '@/lib/query-client';
import { useQuery } from '@tanstack/react-query';

interface ActivityLogParams {
  limit?: number;
  skip?: number;
}

export function useActivityLog(jobId: number, params: ActivityLogParams = {}) {
  const query = useQuery({
    queryKey: [...queryKeys.auditTrail.entity('job', String(jobId)), params],
    queryFn: () => getAuditTrailForEntity('job', jobId, params),
    enabled: jobId > 0,
    staleTime: 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isPending: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
